import { IconDental, IconEyeglass, IconStethoscope } from '@tabler/icons-react';
import { BenefitType } from '@zorro/clients';
import { $enum } from 'ts-enum-util';

export const getBenefitTypeConfig = (benefitType?: BenefitType | null) => {
  return $enum.mapValue(benefitType).with({
    [BenefitType.MAJOR_MEDICAL]: { label: 'Medical', icon: IconStethoscope },
    [BenefitType.SUPPLEMENTAL_DENTAL]: { label: 'Dental', icon: IconDental },
    [BenefitType.SUPPLEMENTAL_COMBINED_DENTAL_VISION]: {
      label: 'Dental',
      icon: IconDental,
    },
    [BenefitType.SUPPLEMENTAL_VISION]: { label: 'Vision', icon: IconEyeglass },
    [BenefitType.SUPPLEMENTAL_ACCIDENT]: null,
    [BenefitType.SUPPLEMENTAL_ACCIDENTAL_DEATH_AND_DISMEMBERMENT]: null,
    [BenefitType.SUPPLEMENTAL_CRITICAL_ILLNESS]: null,
    [BenefitType.SUPPLEMENTAL_FLEXIBLE_SPENDING_ACCOUNT]: null,
    [BenefitType.SUPPLEMENTAL_HOSPITAL]: null,
    [BenefitType.SUPPLEMENTAL_LIFE]: null,
    [BenefitType.SUPPLEMENTAL_OTHER]: null,
    [$enum.handleUnexpected]: null,
    [$enum.handleUndefined]: null,
    [$enum.handleNull]: null,
  });
};

export const getBenefitTypeLabel = (benefitType?: BenefitType | null) => {
  return $enum.mapValue(benefitType).with({
    [BenefitType.MAJOR_MEDICAL]: 'medical',
    [BenefitType.SUPPLEMENTAL_DENTAL]: 'dental',
    [BenefitType.SUPPLEMENTAL_COMBINED_DENTAL_VISION]: 'dental',
    [BenefitType.SUPPLEMENTAL_VISION]: 'vision',
    [BenefitType.SUPPLEMENTAL_ACCIDENT]: '',
    [BenefitType.SUPPLEMENTAL_ACCIDENTAL_DEATH_AND_DISMEMBERMENT]: '',
    [BenefitType.SUPPLEMENTAL_CRITICAL_ILLNESS]: '',
    [BenefitType.SUPPLEMENTAL_FLEXIBLE_SPENDING_ACCOUNT]: '',
    [BenefitType.SUPPLEMENTAL_HOSPITAL]: '',
    [BenefitType.SUPPLEMENTAL_LIFE]: '',
    [BenefitType.SUPPLEMENTAL_OTHER]: '',
    [$enum.handleUnexpected]: '',
    [$enum.handleUndefined]: '',
    [$enum.handleNull]: '',
  });
};
